"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Indeterminate = `"data:image/svg+xml, %3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M2.73315 6H9.26649' stroke='white' strokeWidth='2' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E"`;
exports.default = Indeterminate;
